var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSituationProIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-1,.cls-3{fill-rule:evenodd;}.cls-2{mask:url(#mask);}"), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 9.875,
    y: 45.288,
    width: 480.251,
    height: 419.468,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    className: "cls-1",
    points: "9.877 45.288 490.125 45.288 490.125 464.753 9.877 464.753 9.877 45.288"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "cls-3",
    d: "M155.324,109.4,255.9,85.086a10.121,10.121,0,0,1,4.1-.156,10.315,10.315,0,0,1,8.394,7.719l2.147,8.653,4.956,20.086L159.388,149.469l-.012-.024-4.57,1.115-5.053-20.471-2.038-8.257a10.313,10.313,0,0,1,7.609-12.429M46.714,203.832l100.832-24.389.012.024,248.516-60.1a11.824,11.824,0,0,1,14.231,8.593l24.4,99.726L62.464,317.689,38.055,217.975a11.63,11.63,0,0,1,1.387-8.845,11.747,11.747,0,0,1,7.272-5.3M89.707,428.909l-23-93.89,149.9-36.254,3.425,14.01a18.258,18.258,0,0,0,22.07,13.351l36.782-8.893A18.154,18.154,0,0,0,292.324,295.3l-3.425-14.01L438.947,245l23,93.866a11.727,11.727,0,0,1-8.671,14.166L103.925,437.5a11.771,11.771,0,0,1-14.218-8.593m399.36-94.957-24.8-101.236h.012L436.679,119.962A36.816,36.816,0,0,0,392.311,93.14l-78.195,18.9-5.053-20.47-2.038-8.258A50.207,50.207,0,0,0,246.508,46.7L145.93,71.016A49.825,49.825,0,0,0,109.1,131.168l2.038,8.258,5.053,20.482L37.922,178.856a36.5,36.5,0,0,0-27,44.068L63.32,436.9a36.761,36.761,0,0,0,44.356,26.81l354.4-85.692a36.432,36.432,0,0,0,22.673-16.479,36.005,36.005,0,0,0,4.317-27.59"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSituationProIcon);
export default __webpack_public_path__ + "static/media/SituationProIcon.7ba5a289dab01eb251d833329e6f1a16.svg";
export { ForwardRef as ReactComponent };